import { SlidingStatBar } from 'app/layouts/stats/sliding';
import React from 'react';
import styles from '../view.module.css';
import { RelativeStatCard } from 'app/shared/cards/stat/relative';

export const AudiencePageStatBar = ({ contact_stat = [] }) => {
  return (
    <SlidingStatBar className={styles.slidingStatBar}>
      {contact_stat.map((stat) => (
        <RelativeStatCard
          key={stat.label}
          title={stat.label}
          main_value={stat.main_value}
          current_value={stat.current_value}
          previous_value={stat.previous_value}
          period="month"
        />
      ))}
    </SlidingStatBar>
  );
};
